import { IApplicationData } from "models/application-data";
import { PaginationResponse } from "models/pagination-response";
import { IBannersListResponse } from "models/response/banners-list-response";
import { ILinkServicesListResponse } from "models/response/link-services-list-response";
import { INewsPagedRespomse } from "models/response/news-paged-response";

export type HomeState = {
    banners: IBannersListResponse[];
    linkServices: ILinkServicesListResponse[];
    news: PaginationResponse<INewsPagedRespomse>;
    loading: boolean;
};

export enum ACTION_TYPES {
    setBanners = 'setBanners',
    setLinkServices = 'setLinkServices',
    setNews = 'setNews',
    setLoading = 'setLoading'
}

export const HomeReducer = (state: HomeState, action: any): HomeState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setBanners:
            return {
                ...state,
                banners: payload,
            };
        case ACTION_TYPES.setLinkServices:
            return {
                ...state,
                linkServices: payload,
            };
        case ACTION_TYPES.setNews:
            return {
                ...state,
                news: payload,
            };
        case ACTION_TYPES.setLoading:
            return {
                ...state,
                loading: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}